import { graphql } from "~/lib/graphql";

export const downloadSectionFileFragment = graphql(`
  fragment downloadSectionFileFragment on DownloadSectionFileRecord {
    __typename
    id
    title
    file {
      url
    }
    description(markdown: false)
  }
`);
